'use client';

import { Link } from '@coolblue-development/freddy';
import selectItemOfProductsInWishlistTrigger from '@coolblue-development/ga4-events/triggers/Wishlist/selectItemOfProductsInWishlistTrigger';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { ProductTitleTitle } from '@coolblue-development/next-patterns/client';

type Props = {
  productId: number;
  index: number;
  totalIndices: number;
  href?: string;
  productName: string;
};

export default function TrackedProductTitleTitle({
  productId,
  index,
  totalIndices,
  href,
  productName
}: Props) {
  const { trackEvent } = useAnalytics();

  const handleTracking = () => {
    trackEvent(
      selectItemOfProductsInWishlistTrigger({
        index: index,
        total_indices: totalIndices,
        method: 'title',
        item_id: productId
      })
    );
  };

  return (
    <ProductTitleTitle>
      {href ? (
        <Link href={href} onClick={handleTracking}>
          {productName}
        </Link>
      ) : (
        productName
      )}
    </ProductTitleTitle>
  );
}
